import { useAuth } from "contexts/AuthContext";
import React from "react";
import isGlobalAdmin from "./isGlobalAdmin";

interface GlobalAdminGuardProps {
  children: React.ReactNode;
}

const GlobalAdminGuard = ({ children }: GlobalAdminGuardProps) => {
  const { user } = useAuth();

  if (!isGlobalAdmin(user)) {
    return null;
  }

  return children;
};

export default GlobalAdminGuard;
